import type { Worker } from './type';

export type PersonOption = {
  id: string;
  value: string;
  label: string;
  email?: string;
  avatarUrl?: string;
  disabled: boolean;
};

export const transformWorkerToOption = (
  worker: Worker,
  disabledPersonIds: Set<string>,
): PersonOption => ({
  id: worker.personId,
  value: worker.personId,
  label: worker.name,
  email: worker.primaryWorkerEmail,
  avatarUrl: worker.avatarUrl,
  disabled: disabledPersonIds.has(worker.personId),
});
